module.exports = __webpack_public_path__ + "static/img/34.b86909b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/34.jpg
// module id = G6Lr
// module chunks = 1